/**
 * @author Auto
 * @date 2026/01/26
 * @Description: freightPriceRange -- 运费价格区间配置
 */
<template>
  <div class="freightPriceRange" @keyup.enter="enterSearch">
    <el-form
      class="table-search-bar maintain-form"
      inline
      ref="freightPriceRangeForm"
      :model="freightPriceRangeForm"
      label-width="96px">
      <el-form-item label="状态" prop="status">
        <el-select v-model="freightPriceRangeForm.status" placeholder="请选择" clearable>
          <el-option
            v-for="item in statusArr"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleSearch" icon="el-icon-search">搜索</el-button>
        <el-button type="primary" @click="reset">重置</el-button>
        <el-button type="primary" @click="add">新增</el-button>
      </el-form-item>
    </el-form>
    <el-table
      :data="freightPriceRangeData"
      tooltip-effect="light"
      style="width: 100%">
      <el-table-column
        prop="minDistance"
        label="区间起始距离（公里）"
        :formatter="minDistanceFormatter"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        prop="maxDistance"
        label="区间结束距离（公里）"
        :formatter="maxDistanceFormatter"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        prop="includeMin"
        :formatter="includeMinFormatter"
        label="是否包含最小距离边界"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        prop="includeMax"
        :formatter="includeMaxFormatter"
        label="是否包含最大距离边界"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        prop="unitPrice"
        label="运费单价（元/吨）"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        prop="sortOrder"
        label="排序顺序"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        prop="status"
        :formatter="statusFormatter"
        label="状态"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        prop="updateTime"
        label="更新时间"
        :formatter="dateFormatter"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column label="操作" width="180">
        <template slot-scope="scope">
          <el-button
            size="mini"
            @click="handleEdit(scope.$index, scope.row)">编辑
          </el-button>
          <el-button
            size="mini"
            type="danger"
            @click="handleDelete(scope.$index, scope.row)">删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="listState.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="listState.total"
      :current-page="listState.pageNo"
      background>
    </el-pagination>
    <add-or-edit-dialog
      v-if="addOrEditDialogShow"
      :show.sync="addOrEditDialogShow"
      :info="editInfo"
      @save="handleSave">
    </add-or-edit-dialog>
  </div>
</template>
<script>
import HttpUtil from '@/common/HttpUtil'
import AddOrEditDialog from './addOrEditDialog'

export default {
  name: 'freightPriceRange',
  components: { AddOrEditDialog },
  data () {
    return {
      freightPriceRangeForm: {
        status: ''
      },
      freightPriceRangeData: [],
      addOrEditDialogShow: false,
      editInfo: {},
      listState: {
        pageNo: 1,
        pageSize: 20,
        total: 0
      },
      statusArr: [
        {
          value: '',
          label: '全部'
        },
        {
          value: 0,
          label: '禁用'
        },
        {
          value: 1,
          label: '启用'
        }
      ]
    }
  },
  methods: {
    enterSearch (e) { // 回车搜索
      if (e.target.form && e.target.nodeName === 'INPUT') {
        this.handleSearch()
      }
    },
    handleSearch () {
      const params = {
        status: this.freightPriceRangeForm.status,
        pageNo: this.listState.pageNo,
        pageSize: this.listState.pageSize
      }
      this.getList(params)
    },
    getList (params) {
      HttpUtil.post('manage/freightPriceRange/queryPageInfo', params).then(res => {
        if (res && res.data && res.data.list) {
          this.freightPriceRangeData = res.data.list
          this.listState.total = res.data.total || 0
          this.listState.pageNo = res.data.pageNum || 1
          this.listState.pageSize = res.data.pageSize || 20
        } else {
          this.freightPriceRangeData = []
          this.listState.total = 0
        }
      }).catch(err => {
        this.$message.error(err.message || '查询失败')
      })
    },
    reset () {
      this.$refs['freightPriceRangeForm'].resetFields()
      this.listState.pageNo = 1
      this.handleSearch()
    },
    statusFormatter (row) {
      switch (row.status) {
        case 0:
          return '禁用'
        case 1:
          return '启用'
        default:
          return '-'
      }
    },
    minDistanceFormatter (row) {
      return row.minDistance !== null && row.minDistance !== undefined ? row.minDistance : '无下限'
    },
    maxDistanceFormatter (row) {
      return row.maxDistance !== null && row.maxDistance !== undefined ? row.maxDistance : '无上限'
    },
    includeMinFormatter (row) {
      return row.includeMin === 1 ? '包含' : '不包含'
    },
    includeMaxFormatter (row) {
      return row.includeMax === 1 ? '包含' : '不包含'
    },
    dateFormatter (row) {
      if (!row.updateTime) return '-'
      const date = new Date(row.updateTime)
      return date.toLocaleString('zh-CN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      })
    },
    handleSizeChange (val) {
      this.listState.pageSize = val
      this.listState.pageNo = 1
      this.handleSearch()
    },
    handleCurrentChange (val) {
      this.listState.pageNo = val
      this.handleSearch()
    },
    // 新增
    add () {
      this.editInfo = {}
      this.addOrEditDialogShow = true
    },
    // 编辑
    handleEdit (index, row) {
      this.editInfo = { ...row }
      this.addOrEditDialogShow = true
    },
    // 保存
    handleSave (formData) {
      const isEdit = !!formData.id
      const url = isEdit ? 'manage/freightPriceRange/update' : 'manage/freightPriceRange/add'

      HttpUtil.post(url, formData).then(() => {
        this.$message.success(isEdit ? '编辑成功' : '新增成功')
        this.addOrEditDialogShow = false
        this.handleSearch()
      }).catch(err => {
        this.$message.error(err.message || (isEdit ? '编辑失败' : '新增失败'))
      })
    },
    // 删除
    handleDelete (index, row) {
      this.$confirm('是否确认删除该运费价格区间配置？', '删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        HttpUtil.post('manage/freightPriceRange/delete', { id: row.id }).then(() => {
          this.$message.success('删除成功')
          this.handleSearch()
        }).catch(err => {
          this.$message.error(err.message || '删除失败')
        })
      }).catch(() => {})
    }
  },
  mounted () {
    this.handleSearch()
  }
}
</script>

<style scoped>
</style>
